import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectWheelchairAccessibleFilter } from 'shared/selectors/advancedFilters/accessibleEnvironment';
import { CustomCheckbox } from 'shared/components/CustomCheckbox';

export const WheelchairAccessibleContainer: FC = () => {
  const { label, value } = useSelector(selectWheelchairAccessibleFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, value: boolean) => {
      onChange({ action: 'setWheelchairAccessible', arguments: [value || null] });
    },
    [onChange],
  );

  return <CustomCheckbox label={label} checked={value} onChange={handleChange} />;
};
